/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {EnvironmentalBenefitValueEditor} from "./EnvironmentalBenefitValueEditor";
import React from "react";

export function ProjectedProgramEnvironmentalBenefitsTargetValueEditor(props) {
	let environmentalBenefitId = -1;
	let thisId = props?.Data?.programEnvironmentalBenefitProjectionId || props?.Data?._tempId;

	if (this?.props?.RootData?.ProgramEnvironmentalBenefits) {
		this?.props?.RootData?.ProgramEnvironmentalBenefits.forEach((x) => {
			if (x.ProgramEnvironmentalBenefitProjections && x.ProgramEnvironmentalBenefitProjections.some((y) => y.programEnvironmentalBenefitProjectionId == thisId)) {
				environmentalBenefitId = x.environmentalBenefitId;
			}
		});
	}

	return <EnvironmentalBenefitValueEditor
		environmentalBenefitId={environmentalBenefitId}
		{...props}
	/>
}